export default __webpack_public_path__ + "static/media/rightTail.94a92d07.svg";